var _g, _defs;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAmbassador(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 35,
    viewBox: "0 0 35 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2225_23087)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.7856 11.8888L29.1455 4.89004C28.9617 4.66196 28.6845 4.5293 28.3915 4.5293H26.9809H21.2935H6.60848C6.31553 4.5293 6.03828 4.66189 5.85452 4.89004L0.21438 11.8888C-0.0723615 12.2446 -0.0713624 12.7524 0.216807 13.1071L16.234 32.822V32.8219L16.5061 29.68L19.8348 31.5057L19.8356 31.5055L25.0917 25.036L29.8185 19.2181L34.7833 13.1071C35.0714 12.7524 35.0724 12.2446 34.7856 11.8888Z",
    fill: "#E5CAF3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.234 32.8219L17.7607 31.8165L19.8349 31.5057L19.8351 31.5062L19.8351 31.5062L4.88703 13.1071C4.59893 12.7524 4.59786 12.2446 4.88461 11.8888L10.5247 4.89004C10.7086 4.66196 10.9858 4.5293 11.2787 4.5293H6.60848C6.31553 4.5293 6.03828 4.66189 5.85452 4.89004L0.21438 11.8888C-0.0723615 12.2446 -0.0713624 12.7524 0.216807 13.1071L16.234 32.8219Z",
    fill: "#CB97E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.85475 4.88965L10.3229 12.4985H0.1506L2.09895e-05 12.5014C-0.0014063 12.2844 0.069958 12.0675 0.214114 11.8884L5.85475 4.88965Z",
    fill: "#9857BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.88446 11.8886L7.82318 8.24199L5.85466 4.88965L4.22249 6.91475L0.214239 11.8886C0.0917782 12.0405 0.0222693 12.2201 0.00478504 12.4037C0.00435686 12.4085 0.00350048 12.4132 0.0030723 12.4179C0.0018591 12.4325 0.0018591 12.4472 0.00135955 12.4618C0.000931368 12.4745 -6.77329e-05 12.4873 3.63147e-06 12.5C3.63147e-06 12.5004 7.49958e-05 12.5009 7.49958e-05 12.5014L0.150582 12.4985H4.67023C4.66959 12.2826 4.74102 12.0666 4.88446 11.8886Z",
    fill: "#814AA0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.7859 11.8883C34.9294 12.0667 35.0007 12.283 35 12.4985H34.9922H24.7485L29.1125 5.06731L29.2188 4.98096H29.2195L34.7859 11.8883Z",
    fill: "#9857BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.7483 12.4985L18.8765 32.6847L18.2513 33.4547C17.8638 33.9321 17.1359 33.9321 16.7484 33.4547L16.2339 32.8217L13.4171 23.1354L10.9236 14.5624L10.3228 12.4985H24.7483Z",
    fill: "#CB97E7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8765 32.6845L19.3817 30.9477L13.6304 23.8687L16.2338 32.8215L16.7484 33.4545C16.8643 33.5973 17.011 33.6964 17.1696 33.7538C17.3826 33.8308 17.6171 33.8308 17.8301 33.7538C17.9887 33.6964 18.1354 33.5973 18.2514 33.4545L18.8765 32.6845Z",
    fill: "#BD80E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.2186 4.98103L29.1123 5.06738L24.7484 12.4986L19.8342 4.5293H21.2936H26.9807H28.3915C28.6841 4.5293 28.9617 4.66203 29.1451 4.88969L29.2186 4.98103Z",
    fill: "#AF66DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.9922 12.4985H35.0001C34.9993 12.7148 34.9273 12.9296 34.7831 13.1066L29.8183 19.2175L25.0918 25.0358L18.8767 32.6847L24.7486 12.4985H34.9922Z",
    fill: "#BD80E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3819 30.9478L18.8767 32.6845L19.8348 31.5053L19.3819 30.9478Z",
    fill: "#AF66DA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.8342 4.5293L24.7483 12.4985H10.3228L15.2369 4.5293H19.8342Z",
    fill: "#D9B1EE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.237 4.5293L10.3229 12.4986L5.85474 4.88969C6.03814 4.66203 6.31575 4.5293 6.60834 4.5293H15.237Z",
    fill: "#BD80E1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2751 4.5293H6.60834C6.31575 4.5293 6.03814 4.66203 5.85474 4.88969L7.82332 8.24196L10.5247 4.88983C10.7078 4.66261 10.9835 4.53037 11.2751 4.5293Z",
    fill: "#9857BD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.3786 25.1608C27.1457 24.01 26.4634 22.9995 25.4827 22.3536C25.3814 22.2869 25.3814 22.1383 25.4827 22.0716C26.4634 21.4256 27.1457 20.4152 27.3786 19.2643C27.4038 19.1398 27.5819 19.1398 27.607 19.2643C27.8399 20.4152 28.5223 21.4256 29.5029 22.0716C29.6042 22.1383 29.6042 22.2869 29.5029 22.3536C28.5223 22.9995 27.8399 24.01 27.607 25.1608C27.5818 25.2854 27.4038 25.2854 27.3786 25.1608Z",
    fill: "#FEE97D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.3279 21.1501C12.1325 20.1842 11.5598 19.3362 10.7368 18.7941C10.6518 18.7381 10.6518 18.6134 10.7368 18.5574C11.5598 18.0153 12.1324 17.1674 12.3279 16.2015C12.349 16.0969 12.4985 16.0969 12.5196 16.2015C12.715 17.1673 13.2877 18.0153 14.1107 18.5574C14.1957 18.6134 14.1957 18.7381 14.1107 18.7941C13.2877 19.3362 12.7151 20.1842 12.5196 21.1501C12.4985 21.2546 12.349 21.2546 12.3279 21.1501Z",
    fill: "#FEE97D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0678 4.83277C23.9261 4.13225 23.5107 3.51731 22.9139 3.12416C22.8523 3.08355 22.8523 2.99314 22.9139 2.95246C23.5107 2.55931 23.9261 1.94429 24.0678 1.24385C24.0832 1.16806 24.1915 1.16806 24.2068 1.24385C24.3486 1.94437 24.7639 2.55931 25.3607 2.95246C25.4224 2.99306 25.4224 3.08348 25.3607 3.12416C24.7639 3.51731 24.3486 4.13233 24.2068 4.83277C24.1915 4.90856 24.0831 4.90856 24.0678 4.83277Z",
    fill: "#FEE97D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2225_23087"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmbassador);
export default __webpack_public_path__ + "static/media/ambassador.f59b6d8820121a2550763bf7bfd77176.svg";
export { ForwardRef as ReactComponent };